<script lang="ts">
	import { HeniLogo } from '$global/assets/logos/HeniLogo';
	import { IconLink } from '$global/components/IconLink';
	import { getNavBarContext } from '$global/features/navigation/utils/getNavBarContext/getNavBarContext';

	const { popover } = getNavBarContext();
	const popoverOpen = popover?.states?.open;
</script>

<IconLink
	dataCy="header"
	href="/"
	label="See HENI Home Page"
	onclick={() => {
		popoverOpen?.set(false);
	}}
>
	<HeniLogo
		color={$popoverOpen ? 'gray-900' : 'gray-0'}
		class="xs:scale-100 origin-left scale-75"
	/>
</IconLink>
